export default "__VITE_ASSET__b6f94810__"